"use client";
import React from "react";

export const FilterBar = ({
  searchTerm,
  onSearchChange,
  sortBy,
  sortOrder,
  onSortChange,
}) => {
  const handleSortChange = (field) => {
    // If clicking the same field, toggle order, otherwise set new field with default desc order
    if (field === sortBy) {
      onSortChange(field, sortOrder === "desc" ? "asc" : "desc");
    } else {
      onSortChange(field, "desc");
    }
  };

  const getSortButtonClass = (field) => {
    return `px-3 py-2 text-sm font-medium rounded-lg border ${
      sortBy === field
        ? "bg-rose-50 border-rose-200 text-rose-700"
        : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50"
    }`;
  };

  const getSortIconClass = (field) => {
    if (sortBy !== field) return "opacity-0";
    return sortOrder === "asc" ? "rotate-180" : "";
  };

  return (
    <div className="flex flex-wrap gap-4 items-center mb-6">
      <div className="flex-1 min-w-[300px]">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <svg
              className="w-4 h-4 text-gray-500"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
              />
            </svg>
          </div>
          <input
            type="search"
            className="block w-full p-3 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-rose-500 focus:border-rose-500"
            placeholder="Search by channel name or reviewer..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-600">Sort by:</span>
        <div className="flex gap-1">
          <button
            className={getSortButtonClass("votes")}
            onClick={() => handleSortChange("votes")}
          >
            <div className="flex items-center gap-1">
              <span>Votes</span>
              <svg
                className={`w-4 h-4 transition-transform ${getSortIconClass("votes")}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </button>

          <button
            className={getSortButtonClass("comments")}
            onClick={() => handleSortChange("comments")}
          >
            <div className="flex items-center gap-1">
              <span>Comments</span>
              <svg
                className={`w-4 h-4 transition-transform ${getSortIconClass("comments")}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </button>

          <button
            className={getSortButtonClass("name")}
            onClick={() => handleSortChange("name")}
          >
            <div className="flex items-center gap-1">
              <span>Name</span>
              <svg
                className={`w-4 h-4 transition-transform ${getSortIconClass("name")}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};
